const common = {
  nav_home: 'Accueil',
  nav_about_turkey: 'À propos de la Turquie',
  nav_turkey_culture: 'Culture en Turquie',
  nav_health_institutions: 'Établissements de santé',
  nav_agencies: 'Agences de tourisme de santé',
  nav_contact: 'Contact',

  nav_login: 'Connexion',
  nav_register: 'S\'inscrire',
  nav_user_login: 'Connexion utilisateur',
  nav_user_login_desc: 'Accéder au panneau membre',
  nav_institution_login: 'Connexion établissement',
  nav_institution_login_desc: 'Accéder au panneau établissement',
  nav_admin_login: 'Connexion admin',
  nav_admin_login_desc: 'Gestion de la plateforme',
  nav_my_panel: 'Mon panneau',
  nav_institution_panel: 'Panneau établissement',
  nav_admin_panel: 'Panneau admin',
  nav_user_panel: 'Panneau utilisateur',
  nav_institution_label: 'Établissement',
  nav_admin_label: 'Admin',
  nav_user_label: 'Utilisateur',
  nav_logout: 'Déconnexion',
  nav_warning_title: 'AVIS IMPORTANT',
  nav_warning_text: 'Health Travel Türkiye Platform est une plateforme numérique qui met en relation des personnes ayant besoin de services de santé avec des établissements de santé et des agences de tourisme de santé offrant des services de santé internationaux. Des services de tourisme de santé sont fournis sur cette plateforme. Les établissements de santé sont certifiés et autorisés par les autorités compétentes du pays concerné. Cette plateforme est uniquement à titre informatif et ne contient aucun diagnostic médical, recommandation de traitement ou orientation de santé. L\'opérateur de la plateforme n\'a aucune responsabilité commerciale ou médicale. Veuillez consulter un médecin spécialiste pour vos problèmes de santé.',

  footer_description: 'Accédez aux établissements de santé agréés autorisés par le ministère de la Santé de Turquie. Retrouvez la santé en toute sécurité et rapidement.',
  footer_quick_links: 'Liens rapides',
  footer_for_institutions: 'Pour les établissements',
  footer_institution_login: 'Connexion établissement',
  footer_register: 'S\'inscrire',
  footer_contact: 'Contact',
  footer_email_label: 'E-mail',
  footer_address_label: 'Adresse',
  footer_address_value: 'Istanbul, Turquie',
  footer_rights: 'Tous droits réservés.',
  footer_privacy: 'Politique de confidentialité',
  footer_kvkk: 'Texte d\'information KVKK',
  footer_terms: 'Conditions d\'utilisation',
  footer_powered: 'Powered by Readdy',
  footer_newsletter_title: 'Restez informé',
  footer_newsletter_desc: 'Abonnez-vous pour recevoir les dernières nouvelles sur le tourisme de santé en Turquie.',
  footer_newsletter_placeholder: 'Votre adresse e-mail',
  footer_newsletter_btn: 'S\'abonner',
  footer_newsletter_sending: 'Envoi en cours...',
  footer_newsletter_success: 'Merci ! Vous êtes abonné.',
  footer_newsletter_error: 'Une erreur s\'est produite. Veuillez réessayer.',

  loading: 'Chargement...',
  search: 'Rechercher',
  filter: 'Filtres',
  clear: 'Effacer',
  clear_all: 'Tout effacer',
  all: 'Tous',
  view_all: 'Voir tout',
  view_details: 'Voir les détails',
  explore: 'Explorer',
  back: 'Retour',
  save: 'Enregistrer',
  cancel: 'Annuler',
  submit: 'Soumettre',
  send: 'Envoyer',
  sending: 'Envoi en cours...',
  success: 'Succès',
  error: 'Erreur',
  no_results: 'Aucun résultat trouvé',
  approved: 'Approuvé',
  pro_member: 'PRO',
  doctor_count: '{{count}} Médecin',
  verified: 'Vérifié',
  accreditation: 'Accréditation',
  official_accreditation: 'Accréditation officielle & Garantie',
  health_turkey: 'Health Türkiye',
  health_turkey_desc: 'Plateforme de tourisme de santé',
  ministry_health: 'Ministère de la Santé de la République de Turquie',
  ministry_health_desc: 'Établissement de santé agréé',
  ministry_culture: 'Ministère de la Culture et du Tourisme de la République de Turquie',
  ministry_culture_desc: 'Certificat d\'autorisation de tourisme de santé',
  user_type: 'Utilisateur',
  institution_type: 'Établissement',
  admin_type: 'Admin',

  // Breadcrumb names (Schema.org JSON-LD)
  breadcrumb_home: 'Accueil',
  breadcrumb_contact: 'Contact',
  breadcrumb_institutions: 'Établissements de santé',
  breadcrumb_agencies: 'Agences de tourisme de santé',
  breadcrumb_about_turkey: 'À propos de la Turquie',
  breadcrumb_turkey_culture: 'Culture turque',
  breadcrumb_kvkk: 'KVKK',
  breadcrumb_privacy: 'Politique de confidentialité',
  breadcrumb_terms: 'Conditions d\'utilisation',

  // SEO meta — page titles & descriptions
  seo_home_title: 'Health Travel Türkiye - Plateforme de tourisme de santé en Turquie',
  seo_home_desc: 'Découvrez les établissements de santé accrédités en Turquie pour les patients internationaux. Greffe de cheveux, soins dentaires, chirurgie esthétique, FIV et plus.',
  seo_turkiye_title: 'À propos de la Turquie - Guide de voyage | Health Travel Türkiye',
  seo_turkiye_desc: 'Guide de voyage complet sur la Turquie : villes, sites historiques, merveilles naturelles et informations pratiques.',
  seo_kultur_title: 'Culture turque - Traditions, Cuisine & Vie | Health Travel Türkiye',
  seo_kultur_desc: 'Découvrez le riche patrimoine culturel de la Turquie : traditions, cuisine, festivals, culture du hammam, shopping et vie sociale.',
  seo_contact_title: 'Contact - Health Travel Türkiye',
  seo_contact_desc: 'Contactez Health Travel Türkiye. Rejoignez-nous pour toute question sur le tourisme de santé en Turquie.',
  seo_kvkk_title: 'Texte d\'information KVKK - Protection des données | Health Travel Türkiye',
  seo_kvkk_desc: 'Health Travel Türkiye protection des données personnelles et texte d\'information KVKK.',
  seo_privacy_title: 'Politique de confidentialité - Sécurité des données | Health Travel Türkiye',
  seo_privacy_desc: 'Politique de confidentialité et principes de sécurité des données de Health Travel Türkiye.',
  seo_terms_title: 'Conditions d\'utilisation - Règles de la plateforme | Health Travel Türkiye',
  seo_terms_desc: 'Conditions d\'utilisation et accord utilisateur de Health Travel Türkiye.',

  seo_institutions_title: 'Établissements de santé en Turquie | Health Travel Türkiye',
  seo_institutions_desc: 'Comparez les établissements de santé agréés en Turquie. Trouvez les meilleures cliniques pour greffe de cheveux, soins dentaires, chirurgie esthétique, FIV et plus.',
  seo_agencies_title: 'Agences de tourisme de santé | Health Travel Türkiye',
  seo_agencies_desc: 'Trouvez des agences de tourisme de santé qui organisent votre voyage médical, hébergement et besoins de voyage en Turquie.',
  seo_register_title: 'S\'inscrire - Rejoindre Health Travel Türkiye',
  seo_register_desc: 'Créez votre compte sur Health Travel Türkiye. Inscrivez-vous en tant que patient ou établissement de santé pour accéder à toutes les fonctionnalités.',
};

export default common;
